import BaseModel from './BaseModel'
import {currentDate, currentConseillerId} from '@/helpers'

export default class GroupModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      NOM: '',
      COMMENTAIRES: ''
    }
    super(data, relation, fields)
  }
}
